<template>
    <svg width="512px" height="512px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path
            xmlns="http://www.w3.org/2000/svg"
            d="M320.721,198.144h89.213c10.252,0,15.805,12.002,9.17,19.816l-246.977,290.81  c-6.01,7.076-17.505,1.603-15.803-7.522l34.96-187.391h-89.219c-10.252,0-15.805-12.003-9.168-19.816L339.874,3.23  c6.009-7.076,17.505-1.603,15.803,7.522L320.721,198.144z"
        />
    </svg>
</template>

<script>
export default {
    name: "Trigger",
};
</script>
